import React from "react";
import { useNavigate } from "react-router-dom";
import ProductForm from "../components/admin/ProductForm";

export default function AddProduct() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen" style={{ background: "#0f0f0f" }}>
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="mb-6">
          <button
            onClick={() => navigate(-1)}
            className="flex items-center gap-1 text-sm mb-4 transition-colors"
            style={{ color: "#8A6000" }}
            onMouseEnter={e => e.currentTarget.style.color = "#C8960C"}
            onMouseLeave={e => e.currentTarget.style.color = "#8A6000"}
          >
            <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
            </svg>
            Back to Dashboard
          </button>
          <h1 className="text-2xl font-bold" style={{ color: "#FFD700", fontFamily: "serif", letterSpacing: "0.04em" }}>Add New Warranty Entry</h1>
          <p className="text-sm mt-1" style={{ color: "#5a4a30" }}>Fill in the details below. A warranty card and QR code will be generated automatically.</p>
        </div>
        <div className="card">
          <ProductForm onSuccess={() => navigate("/")} onCancel={() => navigate("/")} />
        </div>
      </div>
    </div>
  );
}
